import type { Mission } from '../missions.ts'

export const ofac: Mission = {
  id: "ofac",
  name: "Office of Foreign Assets Control",
  short: "OFAC",
  call: "Sanctions",
  kind: "subagency",
  parent: "treasury",
  url: "https://ofac.treasury.gov/",
  established: 1950,
  palette: {
    primary: "#015a9c",
    secondary: "#3090d0",
    accent: "#eed763",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Logo_of_the_U.S._Office_of_Foreign_Assets_Control_(OFAC).jpg",
  },
  motif: "globe",
  mission: {
    text: "The Office of Foreign Assets Control (\"OFAC\") of the US Department of the Treasury administers and enforces economic and trade sanctions based on US foreign policy and national security goals against targeted foreign countries and regimes, terrorists, international narcotics traffickers, those engaged in activities related to the proliferation of weapons of mass destruction, and other threats to the national security, foreign policy or economy of the United States.",
    url: "https://ofac.treasury.gov/",
  },
  fact: {
    text: "OFAC was formally created in December 1950, when President Truman declared a national emergency and blocked all Chinese and North Korean assets subject to U.S. jurisdiction.",
    url: "https://ofac.treasury.gov/about-ofac",
  },
  seal: {
    file: "public/seals/ofac.png",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_U.S._Office_of_Foreign_Assets_Control_(OFAC).jpg",
  },
  identifier: {
    about: "https://ofac.treasury.gov/about-ofac",
    accessibility: "https://home.treasury.gov/utility/accessibility",
    foia: "https://home.treasury.gov/footer/freedom-of-information-act",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    performance: "https://home.treasury.gov/about/budget-financial-reporting-planning-and-performance",
    privacy: "https://home.treasury.gov/subfooter/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/ofac-freedmans-bank-building.jpg",
        small: "/media/ofac-freedmans-bank-building-sm.jpg",
        alt: "The colonnaded limestone facade of the Freedman's Bank Building under a blue sky, with bare trees along the sidewalk and a construction crane beyond.",
        title: "Freedman's Bank Building (Treasury Annex), Washington, D.C., November 4, 2023",
        creator: "APK",
        source: "https://commons.wikimedia.org/wiki/File:Freedman%27s_Bank_Building_-_November_2023.jpg",
        license: "CC BY 4.0",
      },
      {
        file: "/media/ofac-treasury-annex-1919.jpg",
        small: "/media/ofac-treasury-annex-1919-sm.jpg",
        alt: "Black-and-white photograph of the newly built Treasury Annex, its row of columns rising above a quiet street lined with bare trees.",
        title: "United States Treasury Annex, Washington, D.C., 1919",
        creator: "National Photo Company Collection, Library of Congress",
        source: "https://commons.wikimedia.org/wiki/File:United_States_Treasury_Annex_LCCN99472293.jpg",
        license: "Public domain (National Photo Company Collection, Library of Congress)",
      },
    ],
  },
}
